import { hasGrayConfigWithoutGroup } from 'utils/gray';
import { adaptMpcExternalOuterPath } from '@mpc/common/src/utils/axios';

export const MENUS_REQUEST_ACTONS_MAPPING = {
  outPendingQuote: 'pendingQuote',
  outConfirmQuote: 'confirmQuote',
  outMaking: 'making',
  outReviewQuote: 'reviewQuote',
  outSettled: 'settled',
  outMyAdvance: 'myAdvance',
  outSettledUpload: 'settledUpload',
  outPaying: 'paying',
  outPayed: 'payed',
};

export const COMMON_FIELDS = [
  {
    custom_field_id: 1,
    field_format: 'date',
    identify: 'begin_at',
    is_required: true,
    name: '开始时间',
  },
  {
    custom_field_id: 2,
    field_format: 'date',
    identify: 'end_at',
    is_required: true,
    name: '结束时间',
  },
  {
    custom_field_id: 49,
    field_format: 'text',
    identify: 'demand_detail_default',
    submit_key: 'description',
    is_required: true,
    name: '需求详情',
    possible_values: '未免退单，请务必准确填写',
  },
];

export const getAttachementDownloadLink = (attachId: number) => {
  if (hasGrayConfigWithoutGroup(['external.demand_attaches_download'])) {
    return adaptMpcExternalOuterPath(`/api/outsource/v2/java_proxy/attachments/${attachId}?download=attachment`);
  }

  return `api/v1/attachments/${attachId}?download=attachment`;
};

export const getAttachementUploadUrl = () => {
  if (hasGrayConfigWithoutGroup(['external.demand_attaches_upload'])) {
    return adaptMpcExternalOuterPath(`/api/outsource/v2/java_proxy/attachments/upload`);
  }

  return `/api/v1/attachments/upload`;
};

export enum QuotationsType {
  YIKOUJIA = 'buyout_price',
  XIAOHAO = 'by_consume',
}
